import {
	ICustomer,
	IWorkOrder,
	ICustomerAddress,
	IUser,
	IWorkOrderFilter,
	IQbInfo,
	IInvoice,
	ILineItem,
	IInvoiceData,
	ICarJob,
	IJobDetail,
	IPaymentData,
	ICustTypeDto,
	IStaff,
	IUserAndPrices,
	SUB_TYPE,
} from "@/interfaces";

export function makeQbInfo(data: Partial<IQbInfo>): IQbInfo {
	const defaultValue: IQbInfo = {};

	return { ...defaultValue, ...data };
}

export function makeCustomerAddress(
	data: Partial<ICustomerAddress>
): ICustomerAddress {
	const defaultValue: ICustomerAddress = {
		CustomerName: "",
		Company: "",
		FName: "",
		LName: "",
		Email: "",
		Phone: "",
		Mobile: "",
		Address: "",
		Address2: "",
		City: "",
		State: "",
		Zip: "",
	};

	return { ...defaultValue, ...data };
}

export function makeCustType(
	data: Partial<ICustTypeDto>
): ICustTypeDto {
	const defaultValue: ICustTypeDto = {
		Name: "",
		ListID: "",
		CustTypeFlags: [],
		IsDealership: false,
		IsRetail: false,
	};
	return { ...defaultValue, ...data };
}

export function makeCustomer(data: Partial<ICustomer>): ICustomer {
	const defaultValue: ICustomer = {
		Shipping: makeCustomerAddress({}),
		Billing: makeCustomerAddress({}),
		QbInfo: makeQbInfo({}),
		CustType: makeCustType({}),
	};

	return { ...defaultValue, ...data };
}

export function makeWorkOrder(data: Partial<IWorkOrder>): IWorkOrder {
	const defaultValue: IWorkOrder = {
		CustomerID: 0,
		InvoiceNum: "",
		Price: 0,
		Deadline: "",
		Year: 0,
		Make: "",
		Model: "",
		Last8Vin: "",
		CarColor: "",
		RimRepairs: 0,
		LF: false,
		RF: false,
		LB: false,
		RB: false,
		WheelLock: false,
		WheelColorType: 0,
		WheelColor: "",
		CaliperColor: "",
		Decals: false,
		DecalDesc: "",
		RepairDescription: "",
	};

	return { ...defaultValue, ...data };
}

export function makeUser(data: Partial<IUser>): IUser {
	const defaultValue: IUser = {
		FName: "",
		LName: "",
		Email: "",
		Phone: "",
		Mobile: "",
		Initials: "",
		IsActive: true,
		IsRep: false,
		Username: "",
		Password: "",
		Roles: [],
		RimRepairListID: "",
		BentRepairListID: "",
	};

	return { ...defaultValue, ...data };
}


// export function makeUserAndPrices(data: Partial<IUserAndPrices>): IUserAndPrices{
// 	const defaultValue: IUserAndPrices = {
// 		User: makeUser({}),
// 		Prices: [],
// 	}
// 	return defaultValue;
// }

export function makeStaff(data: Partial<IStaff>): IStaff {
	const defaultValue: IStaff = {
		  Email : '',
			 FName: '',
			 Initials: '',
			 LName: '',
			 RecordID: 0,
			 Roles: [],
			 IsActive: true,
	};

	return { ...defaultValue, ...data };
}


export function makeWorkOrderFilter(
	data: Partial<IWorkOrderFilter>
): IWorkOrderFilter {
	const defaultValue: IWorkOrderFilter = {
		 Completed: null,
		 CustomerID: null,
		 DeadlineMax: null,
		 DeadlineMin: null,
		 Keyword: null,
		 SentBy: null,
		 SentTo: null,
		 TransferStatus: null,
		 WorkOrderID: null,
	};

	return { ...defaultValue, ...data };
}



export function makeInvoiceData(data: Partial<IInvoiceData>): IInvoiceData {
	const defaultValue: IInvoiceData = {
		//  InvoicePayments: 0,
		// InvoiceSubTotal:0,
		// InvoiceTax:0,
		// InvoiceTotal:0,
		PaymentData: makePaymentData({}),
	};

	return { ...defaultValue, ...data };
}



export function makeInvoice(data: Partial<IInvoice>): IInvoice {
	const defaultValue: IInvoice = {
		EmailRecipients: [],
		MessageForCustomer: '',
		Invoice: {
			InvoiceNumber: "",
			WorkOrderID: 0,
			CustomerID: 0,

			PaymentData: makePaymentData({}),
			//  {
			// 	CustomerSignature: "",
			// 	PayByCheck: false,
			// 	PayByCreditCard: false,
			// 	PayByCash: false,
			// 	PayByPurchaseOrder: false,
			// 	PayByCheckNum: "",
			// 	PayByPONum: "",
			// 	PayByCreditCardLast4: "",
			// 	PayByCreditCardName: "",
			// 	PayByCashAmount: 0,
			// 	PayByCheckAmount: 0,
			// 	PayByCreditCardAmount: 0,
			// 	PayByPOAmount: 0,
			// 	PayByAuth: false,
			// 	PayByAuthNumber: "",
			// 	PayByAuthAmount: 0,
			// 	PaymentNotes: "",
			// 	Tax: null,
			// 	InvoiceSubTotal: 0,
			// 	InvoicePayments: 0,
			// 	InvoiceTax: 0,
			// 	InvoiceTotal: 0,
			// },
			JobNotes: "",
			CarJobs: [],
		},
	};

	return { ...defaultValue, ...data };
}

export function makeLineItem(data: Partial<ILineItem>): ILineItem {
	const defaultValue: ILineItem = {
		ItemID: 0,
		ItemQty: 1,
		ItemName: "",
		ItemPrice: 0,
		ItemTotal: 0,
	};

	return { ...defaultValue, ...data };
}

export function makePaymentData(data: Partial<IPaymentData>): IPaymentData {
	const defaultValue: IPaymentData = {
		CustomerSignature: "",
		PayByCheck: false,
		PayByCreditCard: false,
		PayByCash: false,
		PayByPurchaseOrder: false,
		PayByCheckNum: "",
		PayByPONum: "",
		PayByCreditCardLast4: "",
		PaymentNotes: "",
		PayByCreditCardName: "",
		PayByCashAmount: 0,
		PayByCheckAmount: 0,
		PayByPOAmount: 0,
		PayByCreditCardAmount: 0,
		PayByAuth: false,
		PayByAuthNumber: "",
		PayByAuthAmount: 0,
		Tax: false,
		InvoiceSubTotal:0,
		InvoicePayments: 0,
		InvoiceTax:0,
		InvoiceTotal: 0,
	};

	return { ...defaultValue, ...data };
}



export function makeCarJob(data: Partial<ICarJob>): ICarJob {
	const defaultValue: ICarJob = {
		Year: "",
		Make: "",
		Model: "",
		Last8Vin: "",
		StockNum: "",
		Color: "",
		Mileage: "",
		JobDetails: [],
		SubType: SUB_TYPE.Vehicle,
	};

	return { ...defaultValue, ...data };
}

export function makeJobDetail(data: Partial<IJobDetail>): IJobDetail {
	const defaultValue: IJobDetail = {
		JobType: 0,
		WheelFR: false,
		WheelFL: false,
		WheelBR: false,
		WheelBL: false,
		PricePerWheel: 0,
		JobPrice: 0,
		ServiceItemID: 0,
		ServiceItemName: '',
		LooseWheelCount: 0,
		ServiceQty: 0,
	};

	return { ...defaultValue, ...data };
}
